export const AUTH_STEPS = {
	EMAIL: 'email',
	PASSWORD_LOGIN: 'password_login',
	PASSWORD_REGISTER: 'password_register',
	PASSWORD_SET: 'password_set',
};

export const AUTH_SUBMIT_STATE = {
	IDLE: 'idle',
	PENDING: 'pending',
	SUCCESS: 'success',
};

export const AUTH_SUCCESS_DELAY_MS = 500;
export const AUTH_COMPLETE_DELAY_MS = 2000;
